export default "/_next/static/chunks/fonts/MinionPro-Regular-64cbedab2570dd2f1219fb14d9ac6e14.woff2";